module.exports = __webpack_public_path__ + "media/images/getting-started/instagram-profile-eec19d10bb9c8336fbc183e39232978a.png";